import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import { map } from 'rxjs/operators';
import { DestinationModel } from '@models/destinations.model';
import {AdvertisingMapper} from "@app/mappers";
import {DestinationsRespInt} from "@interfaces/*";
import {MapCMS} from "@mappers/mapCMS.mapper";
import {NoticeModel} from "@models/mapCMS.model";
import {NoticeInt} from "@interfaces/*";

@Injectable({
  providedIn: 'root'
})
export class ImagesCmsService {
  urlCms = environment.cmsUrl;
  mapper = new AdvertisingMapper();
  mapperCanada = new MapCMS()
  public logo = '';
  constructor(private httpClient: HttpClient) { }

  getLogo(): Observable<any>{
    return this.httpClient.get(`${this.urlCms}/?q=files/checkedbaggagetotem-v2png-0`);
  }

  connectCms(): Observable<any> {
    return this.httpClient.get(`${this.urlCms}/api/v1/modal-branded-fares`);
  }

  getDestinations(): Observable<Array<DestinationModel>>{
    return this.httpClient.get<DestinationModel[]>(`${ this.urlCms }/api/v1/destination-info?language=es&status=1`)
    .pipe(
      map (
        ( destinations =>
            destinations.map(
              destination => new DestinationModel(destination)
            )
        )
      )
    );
  }

  getArrivalImages(): Observable<Array<DestinationModel>>{
    return this.httpClient.get<DestinationsRespInt>(`${ this.urlCms }/api/v1/airportsapp`)
      .pipe(
        map (
          ( destinations => this.mapper.mapperAriportJSON(destinations)

          )
        )
      );
  }

  loadCMSImage(arrival: DestinationModel): Observable<string> {
    return this.httpClient.get(`${ arrival }`, {
      responseType: "blob"
    }).pipe(
      map(response => {
        const url = window.URL || window.webkitURL;
        return url.createObjectURL(response)
      })
    );
  }

  loadCMSNoticeImages(): Observable<Array<NoticeModel>> {
    return this.httpClient.get<NoticeInt[]>(`${ this.urlCms}/api/v2/kiosk-destination?status=1`, {

    }).pipe(
      map(response => {
        return this.mapperCanada.mapCMS(response)
      })
    );
  }

}
